import React, { useEffect, useState } from "react"
import Send from "../../core/communication"
import MessageNewsScreen from "../../screen/MessageNewsScreen"

const NewsContentSend = ({
  defaultPostIds = [],
  openModalContent,
  setShowAutoModal,
  selectedPosts,
  setSelectedPosts,
  setAllPosts,
}) => {
  const [open, setOpen] = useState(openModalContent || false)
  const [posts, setPosts] = useState([])
  const [filterPosts, setFilterPosts] = useState([])
  const [loading, setLoading] = useState(false)

  const onSearchTags = (e) => {
    const query = e.target.value
    let updatedList = [...posts]
    updatedList = updatedList.filter(
      (item) => item.title.toLowerCase().indexOf(query.toLowerCase()) !== -1,
    )
    setFilterPosts(updatedList)
  }

  useEffect(() => {
    if (open && !posts.length) {
      setLoading(true)
      Send.get("/posts").then(setPosts)
      setLoading(false)
    }
  }, [open])

  useEffect(() => {
    if (!open) {
      setShowAutoModal(false)
    }
  }, [open])

  useEffect(() => {
    if (defaultPostIds && defaultPostIds.length > 0) {
      setSelectedPosts(defaultPostIds)
    }
    setFilterPosts(posts)
  }, [posts])

  useEffect(() => {
    setAllPosts(
      posts
        .filter((item) => selectedPosts.includes(item.id))
        .map(({ id, title }) => ({
          id,
          title,
        })),
    )
  }, [selectedPosts])

  const changeOptions = (event) => {
    const { checked, value } = event.currentTarget
    setSelectedPosts((prev) => (checked ? [...prev, value] : prev.filter((val) => val !== value)))
  }

  const changeCheckAll = (check, value) => {
    if (value === "true") {
      setSelectedPosts(
        check
          ? [...selectedPosts, check]
          : filterPosts.length === posts.length
          ? posts.map((item) => item.id)
          : filterPosts.map((item) => item.id),
      )
    } else {
      setSelectedPosts(check ? selectedPosts.filter((item) => item.id !== check.id) : [])
    }
  }

  const filteredPosts = () => {
    const allPosts = filterPosts
      .filter((item) => selectedPosts.includes(item.id))
      .map(({ id, title, image }) => ({
        value: id,
        label: title,
        image,
      }))

    return allPosts
  }

  const removeSelectedContent = (value) => {
    const selected = selectedPosts.filter((item) => item !== value)
    setSelectedPosts(selected)
  }

  return (
    <MessageNewsScreen
      {...{
        open,
        openModalContent,
        onSearchTags,
        selectedPosts,
        posts,
        filterPosts,
        filteredPosts,
        setOpen,
        changeOptions,
        changeCheckAll,
        removeSelectedContent,
        loading,
      }}
    />
  )
}

export default NewsContentSend
